import "./carregando.css";

function Produto({ escuro }) {
  return (
    <div className={`flex gap-3 p-3 lg:gap-4 lg:p-4 rounded-2xl border ${escuro ? "bg-zinc-800 border-zinc-700" : "bg-white border-gray-200"}`}>
      <span className="cc-skel w-28 h-28 lg:w-48 lg:h-48 rounded-xl shrink-0" />
      <div className="flex-1 min-w-0 flex flex-col justify-center gap-2">
        <span className="cc-skel h-4 w-3/4" />
        <span className="cc-skel h-3 w-full" />
        <span className="cc-skel h-3 w-2/3" />
        <span className="cc-skel h-4 w-20 mt-1" />
      </div>
    </div>
  );
}

function Secao({ escuro, n }) {
  return (
    <section className="space-y-3">
      <span className="cc-skel h-5 w-40" />
      <div className="flex flex-col gap-2.5 lg:grid lg:grid-cols-2 lg:gap-4">
        {Array.from({ length: n }, (_, i) => <Produto key={i} escuro={escuro} />)}
      </div>
    </section>
  );
}

/**
 * O cardápio do cliente "desenhado" enquanto carrega, no lugar da bolinha
 * girando (dono, 24/10/2026): topo, capa, categorias e cartões de produto no
 * formato real. Usa o tema do próprio cardápio (claro/escuro).
 */
export default function CardapioCarregando({ escuro = false }) {
  return (
    <div className={`min-h-screen ${escuro ? "bg-zinc-900 cc-escuro" : "bg-gray-50 cc-claro"}`}
      aria-label="Carregando cardápio" aria-busy="true" data-e2e="cardapio-carregando">
      <div className={`h-14 px-4 flex items-center gap-3 ${escuro ? "bg-zinc-950" : "bg-white border-b border-gray-100"}`}>
        <span className="cc-skel w-9 h-9 rounded-full shrink-0" />
        <span className="cc-skel h-4 w-36" />
        <span className="cc-skel w-9 h-9 rounded-full ml-auto shrink-0" />
      </div>
      <span className="cc-skel h-36 sm:h-48 w-full rounded-none" />
      <div className="px-4 pt-4 space-y-2">
        <span className="cc-skel h-5 w-48" />
        <span className="cc-skel h-3 w-64 max-w-full" />
      </div>
      <div className="px-4 py-4 flex gap-2 overflow-hidden">
        {[20, 24, 16, 28, 20, 24].map((w, i) => <span key={i} className="cc-skel h-9 rounded-full shrink-0" style={{ width: `${w * 4}px` }} />)}
      </div>
      <div className="px-4 space-y-6 mt-2">
        <Secao escuro={escuro} n={4} />
        <Secao escuro={escuro} n={2} />
      </div>
    </div>
  );
}
